import Tracker from "../Tracker.js";
export default {
  type: 'molten.AmplitudeSetUserId',
  onLoggedIn: (molten, action) => {
    if (action.profile.id) {
      Tracker.set('userId', action.profile.id);
    }
  },
  sort: 10
};